import React from 'react';

import './loader.scss';

const Loader = () => (
  <div className="loader--spinner" />
);

export default Loader;
